
<template>
  <j-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    switchFullscreen
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form" :model="model" :rules="validatorRules">
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="spreadPic" label="宣传图片">
          <j-image-upload text="上传宣传图片" v-model="model.spreadPic" :isMultiple="true"></j-image-upload>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="spreadContent" label="宣传内容">
          <a-textarea v-model="model.spreadContent" rows="4" placeholder="请输入宣传内容" />
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="spreadContent" label="链接地址">
          <a-input v-model="model.spreadLink" rows="4" placeholder="请输入链接地址" />
        </a-form-model-item>

        <a-form-model-item label="投放日期" :labelCol="labelCol" prop="timeRange" :wrapperCol="wrapperCol">
          <a-range-picker format="YYYY-MM-DD" @change="dateChnage" />
        </a-form-model-item>
        <a-form-model-item label="投放时间段" :labelCol="labelCol" prop="timeRange" :wrapperCol="wrapperCol">
          <a-time-picker  @change="timeRange1"   valueFormat="HH:mm:ss"  v-model="model.startTime">
            <a-icon slot="suffixIcon" type="smile" /> </a-time-picker
          >-
          <a-time-picker  @change="timeRange2"   valueFormat="HH:mm:ss"  v-model="model.endTime">
            <a-icon slot="suffixIcon" type="smile" />
          </a-time-picker>
        </a-form-model-item>
        <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" prop="visible" label="审核状态">
          <j-dict-select-tag v-model="model.auditingState" dictCode="auditing_state" />
        </a-form-model-item>
        <!--租户分配-->
        <a-form-item label="租户分配" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-select mode="multiple" style="width: 100%" placeholder="请选择租户分配" v-model="currentTenant">
            <a-select-option v-for="(item, index) in tenantList" :key="index" :value="item.id">
              {{ item.name }}
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-form-model>
    </a-spin>
  </j-modal>
</template>

<script>
import { httpAction, getAction } from '@/api/manage'
import moment from 'moment'
import JDictSelectTag from '@/components/dict/JDictSelectTag'
import JImageUpload from '@/components/jeecg/JImageUpload'
import JUpload from '@/components/jeecg/JUpload'
import JDate from '@/components/jeecg/JDate'
import Vue from 'vue'

export default {
  name: 'SchoolSpreadModal',
  components: {
    JDictSelectTag,
    JImageUpload,
    JUpload,
    JDate,
  },
  data() {
    return {
      rangeConfig: {
        rules: [{ type: 'array', required: true, message: 'Please select time!' }],
      },
      title: '操作',
      visible: false,
      model: {
        startTime:'',
        endTime:''
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },

      confirmLoading: false,
      validatorRules: {},
      url: {
        add: '/aigoes/schoolSpread/add',
        edit: '/aigoes/schoolSpread/edit',
        queryTenantList: '/sys/tenant/queryList',
      },
      tenantList: [],
      currentTenant: [],
      afterNum: '',
      beforeNum: '',

    }
  },
  created() {
    this.initTenantList()
  },
  methods: {
    moment,
    initTenantList() {
      getAction(this.url.queryTenantList).then((res) => {
        if (res.success) {
          this.tenantList = res.result
        }
      })
    },
    add() {
      //初始化默认值
      this.refresh()
      this.edit({ activitiSync: '1' })
    },
    edit(record) {
      this.model = Object.assign({}, record)
      this.visible = true
    },
    close() {
      this.$emit('close')
      this.visible = false
      this.$refs.form.clearValidate()
    },
    dateChnage(value, dateString) {
      this.model['listingDate'] = dateString[0]
      this.model['delistDate'] = dateString[1]
    },
    timeRange1(value, dateString) {
      this.model['startTime'] = dateString
      this.timeFilter(0,dateString)
      if (Number(this.beforeNum)> 0) {
          if(Number( this.afterNum) > Number(this.beforeNum)) {
                this.$message.warning('请选择大于结束的时间点')
                this.model['startTime'] = null
                this.afterNum = ''
          }
      }
    },
    timeRange2(value, dateString) {
      console.log('dateString',dateString)
      this.timeFilter(1,dateString)
      this.model['endTime'] = dateString
      if (Number(this.afterNum)> 0) {
          if(Number( this.beforeNum) < Number(this.afterNum)) {
                this.$message.warning('请选择大于开始的时间点')
                this.model['beforeNum'] = null
                this.beforeNum = ''
          }
      }
    },
    timeFilter(num,dateString) {
      let hour = dateString.split(':')[0]
      let min = dateString.split(':')[1]
      let sec = dateString.split(':')[2]
      let stampStart = Number(hour * 3600) + Number(min * 60) + Number(sec)
      if(num == 0) {
      this.afterNum = stampStart
      }else {
       this.beforeNum = stampStart
      }
    },
    handleOk() {
      const that = this
      // 触发表单验证
      this.$refs.form.validate((valid) => {
        if (valid) {
          that.confirmLoading = true
          let httpurl = ''
          let method = ''
          if (!this.model.id) {
            httpurl += this.url.add
            method = 'post'
          } else {
            httpurl += this.url.edit
            method = 'put'
          }
          this.model.tenantIds = this.currentTenant.length > 0 ? this.currentTenant.join(',') : ''
          httpAction(httpurl, this.model, method)
            .then((res) => {
              if (res.success) {
                that.$message.success(res.message)
                that.$emit('ok')
              } else {
                that.$message.warning(res.message)
              }
            })
            .finally(() => {
              that.confirmLoading = false
              that.close()
            })
        } else {
          return false
        }
      })
    },
    handleCancel() {
      this.close()
    },
    refresh() {
      this.currentTenant = []
    },
  },
}
</script>

<style lang="less" scoped>
</style>